export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const DATE_NUM_H = 28;

export const BAR_AREA_TOP = DATE_NUM_H + 4;
export const DAY_HEADER_H = DATE_NUM_H;
export const SHOP_HEADER_H = 36;
